import React from 'react';

// TODO
const MobileProfile: React.FC<any> = () => null;

export default MobileProfile;
